import React, { useEffect } from "react";
import Sidebar from "../../../components/Sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { api1 } from "../../../utils/axiosInstance";
import { setSubscription } from "../../../redux/authSlice";
import { API_ENDPOINTS } from "../../../services/apiEndpoints";
import { CheckCircle, XCircle } from "lucide-react";

const CompleteSubscription = () => {
  const dispatch = useDispatch();
  const { id: userId } = useSelector((state) => state.auth);
  const [searchParams] = useSearchParams();
  const paymentStatus = searchParams.get("payment");

  useEffect(() => {
    if (paymentStatus === "success") {
      const fetchUpdatedUser = async () => {
        try {
          const response = await api1.get(
            `${API_ENDPOINTS.GET_USER_BY_ID}/${userId}`
          );
          const userData = response.data.data || response.data;
          dispatch(setSubscription(userData.subscription));
        } catch (err) {
          console.error("Failed to fetch updated user:", err);
        }
      };

      fetchUpdatedUser();
    }
  }, [dispatch, userId, paymentStatus]);

  const isSuccess = paymentStatus === "success";

  return (
    <Sidebar>
      <div className="flex flex-col items-center justify-center h-[80vh] px-4">
        <div
          className={`max-w-md w-full p-8 rounded-2xl shadow-lg border 
          ${
            isSuccess
              ? "bg-green-50 border-green-200"
              : "bg-red-50 border-red-200"
          }`}
        >
          <div className="flex flex-col items-center gap-4">
            {isSuccess ? (
              <>
                <CheckCircle size={64} className="text-green-600" />
                <h1 className="text-3xl font-bold text-green-700 text-center">
                  Subscription Updated
                </h1>
                <p className="text-gray-700 text-center">
                  Your plan is now active. Enjoy full access to all features!
                </p>
              </>
            ) : (
              <>
                <XCircle size={64} className="text-red-600" />
                <h1 className="text-3xl font-bold text-red-700 text-center">
                  Payment Failed
                </h1>
                <p className="text-gray-700 text-center">
                  Something went wrong during the payment process. Please try
                  again.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </Sidebar>
  );
};

export default CompleteSubscription;
